import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button } from '@startuptools/ui/Button';
import { Box } from '@startuptools/ui/Box';
import { useTheme } from '@startuptools/ui/Theme';
import { logoNavbar } from '../content/navbarContent';

export const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        width: '100%',
        margin: isMobile ? '0.5rem 0rem ' : '3rem 0rem',
        overflow: 'hidden',
        borderColor: '#FFFFFF',
        maxWidth: '1920px',
      }}
    >
      <AppBar position="static">
        <Toolbar
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#FFFFFF',
          }}
        >
          <a href={logoNavbar.link}>
            <Box
              component="img"
              src={logoNavbar.path}
              alt="Logo"
              sx={{
                display: 'flex',
                alignItems: 'start',
                height: '70px',
                padding: '0.5rem 0rem',
                marginLeft: { md: '3.5rem', lg: '9.5rem', xl: '10rem' },
                marginBottom: isMobile ? '2rem' : '0rem',
              }}
            />
          </a>
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: isMobile ? 'center' : 'flex-end',
              alignItems: 'center',
              gap: 2,
              marginRight: { md: '3.5rem', lg: '4.5rem', xl: '6.625rem' },
              marginBottom: isMobile ? '0.5rem' : '0rem',
            }}
          >
            <a href="https://bolago.com">
              <Button variant="outlined" sx={{ width: isMobile ? '270px' : 'auto' }}>
                Bolago.com
              </Button>
            </a>
            <a href="https://startuptools.org">
              <Button variant="outlined" sx={{ width: isMobile ? '270px' : 'auto' }}>
                StartupTools.org
              </Button>
            </a>
            <a href="https://bolago.app">
              <Button sx={{ width: isMobile ? '270px' : 'auto' }}>Login to the Platform</Button>
            </a>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
